export const CONTACT = {
  fullName: "Abdulrazak Faruk Omogbolahan",
  brandName: "DoshCoder",
  shortName: "Abdulrazak Faruk",
  role: "Founder & Full-Stack Product Engineer",
  location: "Lagos State, Nigeria",
  phoneDisplay: "090 3112 3030",
  phoneRaw: "09031123030",
  phoneIntl: "+2349031123030",
  whatsappNumber: "2349031123030",
  whatsappMessage:
    "Hello Abdulrazak Faruk, I saw your portfolio and I want to work with you.",
  whatsapp:
    "https://wa.me/2349031123030?text=Hello%20Abdulrazak%20Faruk%2C%20I%20saw%20your%20portfolio%20and%20I%20want%20to%20work%20with%20you.",
  emails: ["directordoshvisuals@gmail.com", "codesbydosh@gmail.com"],
  github: "https://github.com/DoshCoder",

  // Google Drive CV links
  cvView:
    "https://drive.google.com/file/d/1pCnfOMfD6Hu17H3yjNwShy67lqfK8AT5/view?usp=sharing",
  cvFile:
    "https://drive.google.com/uc?export=download&id=1pCnfOMfD6Hu17H3yjNwShy67lqfK8AT5",

  profileImage: "/images/abdulrazak-faruk.jpg",
};

export const PROFILE = {
  headline:
    "Building production-focused web and mobile platforms that connect people, businesses, and communities.",
  summary:
    "I am a Software Engineering graduate and the Founder of TapDosh. I design and build practical digital products across commerce, delivery, payments, social connection, and community safety, combining technical problem-solving with real-world product execution.",
  about:
    "I build web applications, mobile products, backend APIs, business websites, payment flows, and administrative systems using React, React Native, Expo, Node.js, Express.js, PostgreSQL, Supabase, and REST APIs.",
  availability:
    "Available for selected product engineering opportunities, technical partnerships, full-stack projects, mobile applications, and business platform development.",
};

export const SKILLS = {
  proficient: [
    "HTML5",
    "CSS3",
    "JavaScript (ES6+)",
    "React.js",
    "React Native",
    "Node.js",
    "Express.js",
    "REST API Integration",
    "Responsive Web Design",
    "Git",
    "GitHub",
  ],
  exploring: [
    "Expo",
    "PostgreSQL",
    "Supabase",
    "Scalable Product Architecture",
    "Payment Infrastructure",
    "Mobile App Deployment",
  ],
  tools: [
    "EAS Build",
    "Paystack Integration",
    "Flutterwave Integration",
    "Vercel",
    "GitHub Actions",
    "MVC Architecture",
    "Technical Documentation",
    "Product Planning",
    "Problem Solving",
  ],
};

export const EXPERIENCE = [
  {
    title: "Founder & Full-Stack Product Engineer",
    company: "TapDosh Limited",
    period: "2024 – Present",
    type: "Product, Web & Mobile Engineering",
    points: [
      "Designed and developed TapDosh as a shared web and mobile ecosystem for commerce, delivery, payments, social connection, and community safety.",
      "Built customer, restaurant, rider, and administrative experiences using React, React Native, Expo, Node.js, Express.js, PostgreSQL, and Supabase.",
      "Implemented product areas including food ordering, package delivery, TapDate, TapChat, TapCredits, notifications, payments, and SafeDosh.",
      "Maintained one shared backend and database truth across web and mobile while preparing production releases for Android and iOS.",
    ],
  },
  {
    title: "Software Development & Digital Solutions Intern",
    company: "Chronicles Software Development Company",
    period: "2023 – 2024",
    type: "NYSC Primary Assignment",
    points: [
      "Contributed to the software development lifecycle for client-facing web applications using modern web technologies.",
      "Worked with cross-functional teams to align software features with business goals and client needs.",
      "Supported technical documentation and product demonstrations for client presentations.",
      "Trained students and instructors on digital boards and tablet software during CSR deployments.",
      "Provided hands-on support and resolved technical issues to improve adoption and learning outcomes.",
    ],
  },
  {
    title: "Independent Web Developer",
    company: "Freelance & Professional Projects",
    period: "2022 – Present",
    type: "Websites & Digital Solutions",
    points: [
      "Built professional websites for academics, businesses, restaurants, public figures, and organisations.",
      "Delivered responsive interfaces, contact flows, business landing pages, and portfolio websites.",
      "Improved frontend quality, usability, mobile responsiveness, and conversion-focused design.",
    ],
  },
];

export const EDUCATION = {
  degree: "BSc Software Engineering",
  school: "Al-Hikmah University, Ilorin, Nigeria",
  year: "2023",
  grade: "Second Class Upper Honours (2:1)",
  coursework: ["Software Architecture", "Web Technologies"],
};

export const HIGHLIGHTS = [
  "Founder of TapDosh Limited",
  "Web, mobile, backend, and product engineering",
  "Commerce, delivery, payment, social, and safety systems",
  "Second Class Upper Software Engineering graduate",
];

export const openWhatsApp = () => {
  const message = encodeURIComponent(CONTACT.whatsappMessage);
  const url = `https://wa.me/${CONTACT.whatsappNumber}?text=${message}`;
  window.open(url, "_blank", "noopener,noreferrer");
};
